import { render, staticRenderFns } from "./newSiteSidebarOtherPages.vue?vue&type=template&id=59d9548a&scoped=true&"
import script from "./newSiteSidebarOtherPages.vue?vue&type=script&lang=js&"
export * from "./newSiteSidebarOtherPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9548a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VSheet})
